import Cookies from 'js-cookie';

const COOKIE_NAME = 'token';

export const getToken = () => Cookies.get(COOKIE_NAME);
export const setToken = (token: string, options?: Cookies.CookieAttributes) =>
  Cookies.set(COOKIE_NAME, token, options);
export const removeToken = () => Cookies.remove(COOKIE_NAME);
